export default "__VITE_ASSET__DG$v78QI__"